import { find } from 'lodash';
import { RootState } from '..';

export const selectSettings = (state: RootState) => find(state.site.settings, {locale: state.ui.locale});
